import { render, staticRenderFns } from "./TableLayout.vue?vue&type=template&id=22e77dfc"
import script from "./TableLayout.vue?vue&type=script&lang=js"
export * from "./TableLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports